export default __webpack_public_path__ + "static/media/bg-pattern.7b3732bb.svg";